module.exports = __webpack_public_path__ + "static/iPhone_background-5391ed0dabe1472b5d3d4be22f22c448.png";